// ============================================================================
// CHINESE SIMPLIFIED TRANSLATIONS - CHAPTER 7: 书信与启示录
// ============================================================================
// 等级 79-91 (13个等级, 39个问题)

export const chapter7Translations = {
  name: "书信与启示录",
  description: "得胜的将承受这一切... 从上头来的智慧使理解成圣",
  
  spiritualWisdom: {
    principle: "从上头来的智慧使理解成圣,使灵魂活过来",
    scripture: "你们中间若有缺少智慧的,应当求那厚赐与众人的神(雅各书1:5)",
    application: "每一封使徒书信和启示录的每一个异象都丰富我们的理解,坚固我们的盼望"
  },
  
  levels: {
    79: {
      name: "在耶路撒冷被捕",
      challenge: "我不但被人捆绑,就是死在耶路撒冷也是愿意的...",
      easy: {
        question: "保罗最后一次访问时在哪里被捕?",
        options: ["安提阿", "以弗所", "耶路撒冷", "哥林多"],
        correctAnswer: 2,
        hint: "经常迫害先知的圣城",
        funFact: "🏛️ 耶路撒冷:神所有仆人荣耀和苦难之地!"
      },
      medium: {
        question: "犹太人指控保罗什么?",
        options: [
          "盗窃圣殿",
          "带外邦人进圣殿亵渎圣殿",
          "亵渎摩西",
          "反叛罗马"
        ],
        correctAnswer: 1,
        hint: "与福音普世性相关的指控",
        funFact: "⛪ 讽刺:保罗被指控亵渎他深深尊敬的圣殿!"
      },
      hard: {
        question: "保罗如何将监禁转化为机会?",
        options: [
          "逃跑了",
          "在当局面前作见证并写了书信",
          "保持沉默",
          "协商释放"
        ],
        correctAnswer: 1,
        hint: "关于将试炼转化为见证",
        funFact: "⛓️ 肉体的锁链,属灵的自由 - 有力的信仰见证!"
      }
    },
    
    80: {
      name: "在巡抚腓力斯面前",
      challenge: "讲论公义、节制和将来的审判时...",
      easy: {
        question: "保罗在哪位巡抚面前为他的信仰作见证?",
        options: ["彼拉多", "腓力斯", "非斯都", "迦流"],
        correctAnswer: 1,
        hint: "以贪婪闻名的巡抚",
        funFact: "⚖️ 腓力斯希望得到贿赂 - 正直面前的腐败!"
      },
      medium: {
        question: "腓力斯对保罗信息的反应是什么?",
        options: [
          "悔改了",
          "害怕颤抖",
          "嘲笑",
          "无动于衷"
        ],
        correctAnswer: 1,
        hint: "良心被真理搅动",
        funFact: "😰 即使腐败者也在神的真理面前颤抖 - 普世良心!"
      },
      hard: {
        question: "腓力斯为什么将保罗囚禁两年?",
        options: [
          "为了保护他",
          "出于政治利益和贪腐期望",
          "忘记了",
          "出于信念"
        ],
        correctAnswer: 1,
        hint: "关于政治和个人算计",
        funFact: "🏛️ 腐败的人类正义 vs 完美的神圣正义 - 鲜明对比!"
      }
    },

    81: {
      name: "上告于凯撒",
      challenge: "我要上告于凯撒!",
      easy: {
        question: "保罗援引什么权利来避免在耶路撒冷受审?",
        options: [
          "庇护权",
          "上告于凯撒(罗马公民)",
          "逃跑权",
          "外交保护"
        ],
        correctAnswer: 1,
        hint: "他的罗马公民身份的特权",
        funFact: "🏛️ 罗马公民权:将福音带到罗马的神圣护照!"
      },
      medium: {
        question: "保罗在离开前在谁面前作见证?",
        options: [
          "公会",
          "亚基帕王和百尼基",
          "罗马士兵",
          "犹太群众"
        ],
        correctAnswer: 1,
        hint: "犹太化的希律王室",
        funFact: "👑 从牧羊人到王宫 - 保罗的神圣提升!"
      },
      hard: {
        question: "神如何使用人类系统来实现他的计划?",
        options: [
          "忽视它们",
          "以护理方式使用它们来实现他的旨意",
          "摧毁它们",
          "总是反对"
        ],
        correctAnswer: 1,
        hint: "关于神对历史的主权",
        funFact: "🌐 罗马司法成为福音的载体 - 非凡的护理!"
      }
    },

    82: {
      name: "在马耳他遭遇海难",
      challenge: "保罗,不要害怕;你必站在凯撒面前...",
      easy: {
        question: "保罗在哪个岛屿遭遇海难?",
        options: ["克里特", "塞浦路斯", "马耳他", "西西里"],
        correctAnswer: 2,
        hint: "西西里南部的小岛",
        funFact: "🏝️ 马耳他:被迫停留变成富有成效的宣教 - 神的绕道!"
      },
      medium: {
        question: "保罗在马耳他行了什么神迹?",
        options: [
          "平静风暴",
          "医治部百流的父亲和其他病人",
          "使食物增多",
          "使死人复活"
        ],
        correctAnswer: 1,
        hint: "在岛上的多次医治",
        funFact: "🏥 保罗:从遇难者到神奇医生 - 神圣的声誉!"
      },
      hard: {
        question: "这次海难如何说明神的信实?",
        options: [
          "意外发生了",
          "神保护并兑现他的应许,尽管有障碍",
          "保罗很幸运",
          "可以避免"
        ],
        correctAnswer: 1,
        hint: "关于神对应许的信实",
        funFact: "⛈️ 风暴、海难、毒蛇:没有什么能阻止神对保罗的计划!"
      }
    },

    83: {
      name: "保罗在罗马",
      challenge: "在自己所租的房子里住了足足两年...",
      easy: {
        question: "保罗在罗马处于什么境况?",
        options: [
          "关在监狱里",
          "软禁在家",
          "完全自由",
          "流放"
        ],
        correctAnswer: 1,
        hint: "受监视的相对自由",
        funFact: "🏠 家监变成宣教中心 - 锁链中的自由!"
      },
      medium: {
        question: "保罗在罗马两年期间做了什么?",
        options: [
          "休息",
          "教导并写书信",
          "准备辩护",
          "观光"
        ],
        correctAnswer: 1,
        hint: "尽管被锁链捆绑仍进行密集的事工",
        funFact: "✍️ 监狱书信:以弗所书、腓立比书、歌罗西书、腓利门书!"
      },
      hard: {
        question: "据传统,保罗如何结束他的事工?",
        options: [
          "病死",
          "公元67年左右在尼禄统治下被斩首",
          "老死",
          "神秘消失"
        ],
        correctAnswer: 1,
        hint: "在疯狂皇帝统治下殉道",
        funFact: "⚔️ '那美好的仗我已经打过了,当跑的路我已经跑尽了' - 最后的胜利!"
      }
    },

    84: {
      name: "罗马书",
      challenge: "我不以福音为耻;这福音本是神的大能,要救一切相信的...",
      easy: {
        question: "哪卷书信最多地发展了因信称义的教义?",
        options: ["哥林多前书", "加拉太书", "罗马书", "以弗所书"],
        correctAnswer: 2,
        hint: "保罗神学的'大教堂'",
        funFact: "🏛️ 罗马书:使奥古斯丁和路德归正的神学杰作!"
      },
      medium: {
        question: "根据罗马书,人如何在神面前称义?",
        options: [
          "靠善行",
          "单单因信,不靠行为",
          "靠祭物",
          "靠传统"
        ],
        correctAnswer: 1,
        hint: "宗教改革的基本原则",
        funFact: "⚖️ '义人必因信得生' - 保罗的属灵革命!"
      },
      hard: {
        question: "这封书信的普世范围是什么?",
        options: [
          "只涉及罗马人",
          "阐述全人类的救恩计划",
          "只批评罗马",
          "已过时"
        ],
        correctAnswer: 1,
        hint: "关于普世救恩计划",
        funFact: "🌍 福音 = 神拯救所有人的大能:犹太人和希腊人 - 完全的普世性!"
      }
    },

    85: {
      name: "爱的颂歌 - 哥林多前书13章",
      challenge: "我若能说万人的方言,并天使的话语,却没有爱...",
      easy: {
        question: "圣经哪一章被称为'爱的颂歌'?",
        options: [
          "哥林多前书12章",
          "哥林多前书13章",
          "约翰一书4章",
          "罗马书8章"
        ],
        correctAnswer: 1,
        hint: "哥林多前书的中心章节",
        funFact: "💝 婚礼上最常读的章节 - 爱的完美定义!"
      },
      medium: {
        question: "保罗对爱的持久性说了什么?",
        options: [
          "爱会随时间流逝",
          "爱是永不止息",
          "爱取决于环境",
          "爱是暂时的"
        ],
        correctAnswer: 1,
        hint: "神之爱的永恒性",
        funFact: "♾️ 只有爱跨越死亡和永恒 - 至高价值!"
      },
      hard: {
        question: "保罗为什么将爱置于属灵恩赐之上?",
        options: [
          "恩赐是坏的",
          "爱赋予其他一切意义和价值",
          "爱更容易",
          "恩赐分裂人"
        ],
        correctAnswer: 1,
        hint: "关于一切服事的动力和意义",
        funFact: "🎯 没有爱,即使最大的恩赐也变成噪音和骄傲!"
      }
    },

    86: {
      name: "以弗所书:教会是基督的身体",
      challenge: "将万有服在他的脚下,使他为教会作万有之首...",
      easy: {
        question: "根据以弗所书,教会与基督的关系是什么?",
        options: [
          "他的殿",
          "他的身体",
          "他的家",
          "他的军队"
        ],
        correctAnswer: 1,
        hint: "合一的有机比喻",
        funFact: "👤 基督的身体:每个基督徒都是重要的肢体 - 相互依存!"
      },
      medium: {
        question: "保罗描述什么军装用于属灵争战?",
        options: [
          "物理盔甲",
          "神的全副军装:真理、公义、平安、信德、救恩、圣道",
          "罗马盔甲",
          "魔法保护"
        ],
        correctAnswer: 1,
        hint: "六件属灵盔甲",
        funFact: "⚔️ 属灵争战用属灵武器 - 得胜的神圣战略!"
      },
      hard: {
        question: "根据保罗,我们真正的争战是针对谁?",
        options: [
          "针对恶人",
          "针对属灵的邪恶势力",
          "针对政府",
          "针对贫穷"
        ],
        correctAnswer: 1,
        hint: "关于看不见的属灵力量",
        funFact: "👹 宇宙性争战:人类冲突背后是真实的属灵战争!"
      }
    },

    87: {
      name: "腓立比书:患难中的喜乐",
      challenge: "你们要靠主常常喜乐;我再说,你们要喜乐!",
      easy: {
        question: "保罗尽管被囚禁仍鼓励什么情感?",
        options: ["顺从", "喜乐", "愤怒", "悲伤"],
        correctAnswer: 1,
        hint: "对囚犯来说令人惊讶的情感",
        funFact: "😊 四章中16次提到喜乐 - 监狱中幸福的记录!"
      },
      medium: {
        question: "根据腓立比书2章,耶稣采取了什么态度?",
        options: [
          "用强力强加",
          "自己卑微,存心顺服,以至于死",
          "逃避责任",
          "寻求荣耀"
        ],
        correctAnswer: 1,
        hint: "自愿的下降运动",
        funFact: "📉 耶稣:从与神同等到十字架之死 - 极致的爱!"
      },
      hard: {
        question: "保罗如何能在监狱中宣讲喜乐?",
        options: [
          "在假装",
          "基督徒的喜乐超越环境",
          "是受虐狂",
          "否认现实"
        ],
        correctAnswer: 1,
        hint: "关于超自然的喜乐",
        funFact: "✨ 喜乐 = 圣灵的果子,独立于环境 - 神圣的秘密!"
      }
    },

    88: {
      name: "教牧书信",
      challenge: "要为信仰打那美好的仗,持定永生...",
      easy: {
        question: "保罗给谁写了他最后的教牧书信?",
        options: [
          "给哥林多人",
          "给提摩太和提多",
          "给罗马人",
          "给加拉太人"
        ],
        correctAnswer: 1,
        hint: "他属灵的儿子和同工",
        funFact: "👨‍👦 属灵遗嘱:保罗将火炬传给下一代!"
      },
      medium: {
        question: "保罗对选择教会领袖给出什么建议?",
        options: [
          "选择最富有的",
          "按照严格的道德和属灵标准选择",
          "选择最有学问的",
          "选择最受欢迎的"
        ],
        correctAnswer: 1,
        hint: "首先是道德资格",
        funFact: "⚖️ 领袖的高标准:品格优先于能力 - 神圣的优先次序!"
      },
      hard: {
        question: "保罗给提摩太留下什么遗产?",
        options: [
          "物质财产",
          "对福音的忠诚和牧养事工",
          "政治职位",
          "神学院"
        ],
        correctAnswer: 1,
        hint: "关于属灵遗产",
        funFact: "📜 '保守所托付你的' - 世世代代忠实传递福音!"
      }
    },

    89: {
      name: "希伯来书:耶稣大祭司",
      challenge: "我们有一位已经升入高天尊荣的大祭司...",
      easy: {
        question: "根据希伯来书,谁是我们的大祭司?",
        options: ["亚伦", "摩西", "耶稣", "麦基洗德"],
        correctAnswer: 2,
        hint: "神与人之间完美的中保",
        funFact: "✝️ 耶稣:既是祭司又是祭物 - 一次完美的献祭!"
      },
      medium: {
        question: "为什么耶稣的祭司职分高于亚伦的?",
        options: [
          "更古老",
          "照着麦基洗德的等次永远长存",
          "更富有",
          "更受欢迎"
        ],
        correctAnswer: 1,
        hint: "永恒vs暂时",
        funFact: "♾️ 永远的祭司职分:耶稣永远为我们代求!"
      },
      hard: {
        question: "希伯来书如何呈现新约?",
        options: [
          "与旧约相同",
          "更好且最终的,写在心上",
          "暂时的",
          "可选的"
        ],
        correctAnswer: 1,
        hint: "关于成全和超越",
        funFact: "📋 新约:律法写在心上,不在石版上!"
      }
    },

    90: {
      name: "雅各书:信心与行为",
      challenge: "信心若没有行为就是死的...",
      easy: {
        question: "根据雅各书,什么应当伴随信心?",
        options: [
          "言语",
          "行为",
          "情感",
          "知识"
        ],
        correctAnswer: 1,
        hint: "信心的实际表现",
        funFact: "🌳 信心 = 根,行为 = 果子 - 完整的属灵树!"
      },
      medium: {
        question: "雅各将舌头比作什么?",
        options: [
          "剑",
          "点燃大森林的小火",
          "乐器",
          "工具"
        ],
        correctAnswer: 1,
        hint: "小肢体但破坏力巨大",
        funFact: "🔥 舌头:小肢体但能燃烧整个人生 - 当心!"
      },
      hard: {
        question: "如何调和雅各和保罗关于信心/行为的教导?",
        options: [
          "他们矛盾",
          "保罗讲称义,雅各讲成圣",
          "一个错了",
          "没有解决方案"
        ],
        correctAnswer: 1,
        hint: "关于两个互补的方面",
        funFact: "⚖️ 保罗:因信得救 / 雅各:信心由行为证明 - 完美和谐!"
      }
    },

    91: {
      name: "启示录:王的再来",
      challenge: "看哪,我必快来。凡遵守这书上预言的有福了!",
      easy: {
        question: "约翰在启示录中给几个教会写信?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "完全的数字",
        funFact: "⛪ 亚细亚七教会:所有时代所有教会的镜子!"
      },
      medium: {
        question: "根据启示录,历史如何结束?",
        options: [
          "完全毁灭",
          "新天新地",
          "回到地上乐园",
          "一切存在的终结"
        ],
        correctAnswer: 1,
        hint: "创造的完全更新",
        funFact: "🌅 不是世界的终结而是全面更新 - 终极盼望!"
      },
      hard: {
        question: "启示录向受迫害者传达什么核心信息?",
        options: [
          "投降",
          "基督掌权并将最终得胜",
          "逃避迫害",
          "报仇"
        ],
        correctAnswer: 1,
        hint: "关于最终胜利的盼望",
        funFact: "👑 '昔在、今在、以后永在的' - 历史和时间的主!"
      }
    }
  }
};

export default chapter7Translations;
